/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectLotEmployeeEventResource
 */
export interface ProjectLotEmployeeEventResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectLotEmployeeEventResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectLotEmployeeEventResource
     */
    correlationId: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectLotEmployeeEventResource
     */
    lotId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectLotEmployeeEventResource
     */
    eventType: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProjectLotEmployeeEventResource
     */
    payload: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof ProjectLotEmployeeEventResource
     */
    occurredAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ProjectLotEmployeeEventResource
     */
    actorId?: string;
}

/**
 * Check if a given object implements the ProjectLotEmployeeEventResource interface.
 */
export function instanceOfProjectLotEmployeeEventResource(value: object): value is ProjectLotEmployeeEventResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('correlationId' in value) || value['correlationId'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('payload' in value) || value['payload'] === undefined) return false;
    if (!('occurredAt' in value) || value['occurredAt'] === undefined) return false;
    return true;
}

export function ProjectLotEmployeeEventResourceFromJSON(json: any): ProjectLotEmployeeEventResource {
    return ProjectLotEmployeeEventResourceFromJSONTyped(json, false);
}

export function ProjectLotEmployeeEventResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectLotEmployeeEventResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'correlationId': json['correlationId'],
        'lotId': json['lotId'] == null ? undefined : json['lotId'],
        'eventType': json['eventType'],
        'payload': json['payload'],
        'occurredAt': (new Date(json['occurredAt'])),
        'actorId': json['actorId'] == null ? undefined : json['actorId'],
    };
}

export function ProjectLotEmployeeEventResourceToJSON(value?: ProjectLotEmployeeEventResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'correlationId': value['correlationId'],
        'lotId': value['lotId'],
        'eventType': value['eventType'],
        'payload': value['payload'],
        'occurredAt': ((value['occurredAt']).toISOString()),
        'actorId': value['actorId'],
    };
}

